import React, { ReactElement } from 'react'
import { box } from 'styled-system/patterns'
import { NavItem } from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { useSignedOutNavMobileContext } from '@mindfulchefuk/features/Navigation/components/Header/SignedOutNav/context/SignedOutNavMobileContext'
import { SignedOutNavMobileCTAs } from '@mindfulchefuk/features/Navigation/components/Header/SignedOutNav/SignedOutNavMobile/SignedOutNavMobileCTAs'

export const SignedOutNavMobileBottomSection = (): ReactElement => {
  const { handleCloseMobileNav } = useSignedOutNavMobileContext()
  return (
    <div
      className={box({
        px: 6,
        py: 3,
        borderTopWidth: 1,
        color: 'aubergine',
        borderColor: 'pumpkin.200',
      })}
    >
      <NavItem
        id="help"
        hasSubMenu={false}
        href="https://help.mindfulchef.com/"
        onClick={handleCloseMobileNav}
      >
        Help
      </NavItem>
      <SignedOutNavMobileCTAs />
    </div>
  )
}
